// extracted by mini-css-extract-plugin
export default {"footerBg":"gb-z","footerTopLinks":"hb-z","footerFeedback":"ib-z","footerSocial":"jb-z","footerLegalLinks":"kb-z","footerIconCards":"lb-z","footerBotCopy":"mb-z"};